<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<div class="k-page-wrapper">
		<h1 class="k-page-title d-flex align-center">
			<k-btn icon large color="primary" class="mr-2" accessible-label="Return to admin main" @click="return_to_admin_main"><k-icon>fas fa-user-cog</k-icon></k-btn>
			<div>Manage User Accounts</div>
			<k-spacer/>
			<k-btn v-if="site_config.enable_new_user_creation_from_admin_users=='yes'" class="k-tight-btn" color="primary" @click="user_being_created = true"><k-icon small class="mr-2">fas fa-plus</k-icon> Add New User</k-btn>
			<k-btn class="ml-6 k-nocaps-btn k-tight-btn" @click="mode='all'">Show ALL Users</k-btn>
			<k-btn class="ml-3 k-nocaps-btn k-tight-btn" color="#ccc" @click="mode='admin'">Show ADMIN Users</k-btn>
		</h1>

		<div v-if="recent_stats" class="mt-4 d-flex align-center">
			<k-spacer/>
			<div class="text-center">
				<div><b>Recent activity:</b></div>
				<div class="mt-1">{{recent_stats_time}}</div>
				<k-btn small color="primary" class="mt-2"
					@click="get_recent_stats"
				><k-icon small class="mr-1">fas fa-arrows-rotate</k-icon>Refresh</k-btn>
			</div>
			<table class="ml-6 k-admin-users-recent-stats-table">
				<tr>
					<th></th>
					<th class="text-center">Last 15 Minutes</th>
					<th class="text-center">Last hour</th>
					<th class="text-center">Last 24 hours</th>
				</tr>
				<tr v-for="(stats, header) in recent_stats" :key="header">
					<th>{{header}}</th>
					<td>{{stats[0]}}</td>
					<td>{{stats[1]}}</td>
					<td>{{stats[2]}}</td>
				</tr>
			</table>
			<k-spacer/>
		</div>

		<div v-if="mode=='admin'" style="clear:both">
			<AdminUsersAdmin />
		</div>

		<div v-else-if="mode=='all'" style="clear:both">
			<AdminUsersAll />
		</div>

		<div v-else class="mt-8 mb-3">
			<i>This area allows you to manage {{ site_config.app_name }} users, including which users have administrative access to do such things as authoring/edit Courses. To get started, click the SHOW ALL USERS” or SHOW ADMIN USERS” button above.</i>
		</div>

		<AdminNewUser v-if="user_being_created" @editor_cancel="user_being_created=false" />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import AdminUsersAdmin from './AdminUsersAdmin'
import AdminUsersAll from './AdminUsersAll'
import AdminNewUser from './AdminNewUser'

export default {
	components: { AdminNewUser, AdminUsersAdmin, AdminUsersAll },
	
	data() { return {
		mode: null,
		user_being_created: false,
		recent_stats: null,
		recent_stats_time: ''
	}},

	computed: {
		...mapState(['user_info', 'all_courses_loaded', 'all_courses', 'site_config', 'todo_user_group_divisions', 'todo_user_group_schools']),
	},

	created() {
		// DEBUG
		vapp.admin_users_component = this
		this.get_recent_stats()
	},
	
	methods: {
		return_to_admin_main() {
			this.$router.push({ path: '/' })
		},

		get_recent_stats() {
			U.ajax('admin_get_recent_stats', {user_id: this.user_info.user_id}, result =>{
				if (result.status != 'ok') {
					vapp.$alert('A problem occurred while attempting to retrieve recent stats')
				}
				// console.log(result)
				this.recent_stats = {
					// 'New Users Created': [result.signin_counts.created_at_15m, result.signin_counts.created_at_60m, result.signin_counts.created_at_24h, ],
					'Users Signed In [new]': [
						`${result.signin_counts.signin_15m} [${result.signin_counts.created_at_15m}]`, 
						`${result.signin_counts.signin_60m} [${result.signin_counts.created_at_60m}]`, 
						`${result.signin_counts.signin_24h} [${result.signin_counts.created_at_24h}]`, 
					],
					'Users Accessing Resources': [result.access_counts.unique_user_accesses_15m, result.access_counts.unique_user_accesses_60m, result.access_counts.unique_user_accesses_24h, ],
					'Resource Access Count': [result.access_counts.total_accesses_15m, result.access_counts.total_accesses_60m, result.access_counts.total_accesses_24h, ],
				}
				this.recent_stats_time = date.format(new Date(), 'M/D/YY h:mm A')
			})
		},
	}
}
</script>

<style lang="scss">
.k-admin-users-recent-stats-table {
	border-collapse: collapse;
	th, td {
		font-size:14px;
		padding:4px 8px;
		border:1px solid #ddd;
	}
	th {
		font-weight:normal;
		text-align:left;
		background-color:#eee;
	}
	td {
		width:120px;
		text-align:center;
	}
}
</style>
